/**
 * Auth Module
 */
export const LOGIN = "LOGIN";
export const USER = "USER";
export const ORGANISATION = "ORGANISATION";
export const ORGANISATIONS = "ORGANISATIONS";
export const WALLET = "WALLET";
export const SWITCH_KEY = "SWITCH_KEY";
export const LOGOUT = "LOGOUT";
